import React from "react";
import { ReactComponent as GreenCheck } from "images/check_circle_green.svg";
import "./sideAddressDetails.scss"
export type StatusType = "verified" | "warning" | "unverified" | "active" | "blacklist" | "undeliverable" | "";

interface DetailRowProps {
  label: string;
  value: string | string[];
  verifiedBy?: string;
  verifiedDate?: string;
  status?: string ;
}

const DetailRow: React.FC<DetailRowProps> = ({ label, value, verifiedBy, verifiedDate, status }) => (
  <div className="detail-row">
    <div className="label">{label}</div>
    <div className="labelValue">
      {Array.isArray(value) ? (
        value.map((v, i) => <div key={i}>{v}</div>)
      ) : (
        <div className="boxvalue"><span>{value}</span>{status && <GreenCheck className="check-icon"/>}</div>
      )}
      {verifiedBy && (
        <div className="verified-info">
          Verified by {verifiedBy} on {verifiedDate}
        </div>
      )}
    </div>
  </div>
);

export default DetailRow;
